export default __webpack_public_path__ + "static/media/Toray_Group_rogo.55368ea2.svg";